import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=1f8f05c6&scoped=true&"
import script from "./BlogPost.vue?vue&type=script&lang=js&"
export * from "./BlogPost.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./BlogPost.vue?vue&type=style&index=0&id=1f8f05c6&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1f8f05c6",
  "01631074"
  
)

export default component.exports